// import React, { useState, useEffect, useRef } from "react";
// import { toast } from "sonner";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import { Menu, Trash2 } from "lucide-react";
// import { Api } from "../Api/Api";

// function Retail() {
//   const location = useLocation();
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [cart, setCart] = useState([]);
//   const [showRetailForm, setShowRetailForm] = useState(false);
//   const [customer, setCustomer] = useState({
//     name: "",
//     mobile: "",
//     address: "",
//   });
//   const [isRetailMode, setIsRetailMode] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // const [discount, setDiscount] = useState(0); // ❌ REMOVED: total discount %
//   const [paymentType, setPaymentType] = useState("Cash");
//   const [paidAmount, setPaidAmount] = useState(0);

//   const [username, setUsername] = useState("");

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("currentUser"));
//     if (user) {
//       setUsername(user.username); // ✅ store username in state
//     }
//   }, []);

//   // ✅ New states for invoice
//   const [invoiceNo, setInvoiceNo] = useState("");
//   const inputRef = useRef(null);

//   useEffect(() => {
//     fetchProducts();
//     generateInvoiceNo();
//   }, [location.pathname]);

//   // ✅ Auto-generate invoice no
//   const generateInvoiceNo = () => {
//     const now = new Date();
//     const unique = "INV" + now.getTime(); // Eg: INV1692523244231
//     setInvoiceNo(unique);
//   };

//   const filteredProducts = (
//     selectedCategory
//       ? products.filter((p) => p.category === selectedCategory)
//       : products
//   ).filter((p) => p.product.toLowerCase().includes(searchTerm.toLowerCase()));

//   const addToCart = (product) => {
//     const exists = cart.find((item) => item.id === product.id);
//     if (exists) {
//       // stop if quantity already reached stock
//       if (exists.quantity >= product.stock) {
//         toast.error(
//           `Only ${product.stock} stock available for ${product.product}`
//         );
//         return;
//       }
//       setCart(
//         cart.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         )
//       );
//     } else {
//       if (product.stock < 1) {
//         toast.error(`No stock available for ${product.product}`);
//         return;
//       }
//       setCart([...cart, { ...product, quantity: 1 }]);
//     }
//   };

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(`${Api}product/read.php`);
//       const allProducts = res.data;
//       setProducts(allProducts);
//       const uniqueCats = [
//         ...new Set(allProducts.map((p) => p.category).filter(Boolean)),
//       ];
//       setCategories(uniqueCats);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     }
//   };
//   // ✅ Always keep scanner input focused
//   useEffect(() => {
//     inputRef.current.focus();
//     const handleFocus = () => inputRef.current.focus();
//     window.addEventListener("click", handleFocus);
//     return () => window.removeEventListener("click", handleFocus);
//   }, []);

//   // ✅ Handle barcode scan
//   const handleScan = (e) => {
//     if (e.key === "Enter") {
//       const scannedCode = e.target.value.trim();
//       e.target.value = "";

//       const product = products.find((p) => p.barcode === scannedCode);
//       if (product) {
//         addToCart(product);
//         toast.success(`${product.product} added to cart`);
//       } else {
//         toast.error("No product matches this barcode");
//       }
//     }
//   };
//   const removeFromCart = (id) => {
//     setCart(cart.filter((item) => item.id !== id));
//   };
//   const getSubTotal = () => {
//     return cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
//   };

//   // ❌ REMOVED: getDiscountAmount function

//   const getTotalAmount = () => getSubTotal(); // ✅ Total is now just SubTotal

//   const getBalance = () => {
//     if (paymentType === "Credit") {
//       return Math.max(0, getTotalAmount() - paidAmount);
//     }
//     return 0;
//   };

//   const handleRetailCheckout = async () => {
//     if (!customer.name || !customer.mobile || !customer.address) {
//       return toast.error("Enter all customer details");
//     }

//     // ✅ Mobile number validation (must be 10 digits)
//     if (!/^\d{10}$/.test(customer.mobile)) {
//       return toast.error("Enter a valid 10-digit mobile number");
//     }

//     const retailOrder = {
//       invoiceNo,
//       customer,
//       cart,
//       subtotal: getSubTotal(),
//       total: getTotalAmount(),
//       paymentType,
//       paidAmount: paymentType === "Credit" ? paidAmount : getTotalAmount(),
//       balance: getBalance(),
//       timestamp: new Date().toISOString(),
//       date: new Date().toLocaleDateString(),
//       billername: username,
//     };

//     try {
//       const res = await axios.post(
//         `${Api}retail/retail_save.php`,
//         retailOrder,
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       const invoiceNo = res.data.invoiceNo;

//       console.log("📦 Data being sent to backend:", retailOrder);

//       await Promise.all(
//         cart.map((item) =>
//           axios.put(
//             `${Api}product/update.php?id=${item.id}`,
//             { stock: item.stock - item.quantity },
//             { headers: { "Content-Type": "application/json" } }
//           )
//         )
//       );

//       const billContent = `
// <html>
// <head>
//   <title>Invoice ${invoiceNo}</title>
//   <style>
//     body {
//       font-family: 'Arial', sans-serif;
//       font-size: 12px;
//       color: #000;
//       margin:0;
//       padding:0;
//       display:flex;
//       justify-content:center;
//       align-items:center;
//     }

//     .page {
//       width: 186mm;
//       height: 273mm;
//       border: 2px solid #000;
//       padding: 8mm;
//       box-sizing: border-box;
//       margin: 12mm auto;
//       position: relative;
//     }

//     table { border-collapse: collapse; width: 100%; }
//     th, td { border: 1px solid #000; padding: 6px; font-size: 12px; }
//     th { font-weight: bold; text-align: center; font-size: 13px; }
//     .no-border { border: none !important; }

//     .watermark {
//       position: absolute;
//       top: 50%; left: 50%;
//       transform: translate(-50%, -50%);
//       opacity: 0.07;
//       z-index: 0;
//     }
//     .watermark img { width: 380px; height: auto; }

//     .header-table td { border: none !important; vertical-align: middle; }

//     @media print {
//       @page { size: A4; margin: 0; }
//       body { margin: 0; }
//     }
//   </style>
// </head>
// <body>

// <div class="page">

//   <div class="watermark">
//     <img src="/logo.jpg" />
//   </div>

//   <table class="header-table" style="margin-bottom:12px; position:relative; z-index:1; width:100%;">
//     <tr>
//       <td style="width:15%; text-align:center;">
//         <img src="/logo.jpg" style="width:100px; height:100px;" />
//       </td>
//       <td style="text-align:center;">
//         <div style="display:flex; flex-direction:column; align-items:center; justify-content:center;">
//           <h2 style="margin:0; font-size:20px; font-weight:bold;">
//             ஸ்ரீ முருகன் ஆயுர்வேத ஆளோசனை மையம்
//           </h2>
//           <p style="margin:2px 0; font-size:11px;">
//             142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301
//           </p>
//           <p style="margin:2px 0; font-size:11px;">
//             📞 99408 32688 / 90801 99109 &nbsp;&nbsp; ✉️ srimuruganayurveda@gmail.com
//           </p>
//         </div>
//       </td>
//       <td style="width:22%; text-align:right; font-size:12px;">
//         <p><b>Invoice No:</b> ${invoiceNo}</p>
//         <p><b>Date:</b> ${new Date().toLocaleDateString("en-GB", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//         })}</p>
//       </td>
//     </tr>
//   </table>

//   <table style="margin-bottom:12px; position:relative; z-index:1; width:100%;">
//     <tr>
//       <td style="padding:6px; font-size:12px;">
//         <b>To M/s:</b> ${customer.name}, ${customer.address}<br/><br/>
//         <b>Mobile:</b> ${customer.mobile}
//       </td>
//     </tr>
//   </table>

//   <table style="position:relative; z-index:1; width:100%; margin-bottom:15px;">
//     <thead>
//       <tr>
//         <th style="width:8%;">S.No</th>
//         <th style="width:42%;">Particulars</th>
//         <th style="width:15%;">Rate</th>
//         <th style="width:10%;">Qty</th>
//         <th style="width:25%;">Amount</th>
//       </tr>
//     </thead>
//     <tbody>
//       ${cart
//         .map(
//           (item, idx) => `
//         <tr>
//           <td style="text-align:center;">${idx + 1}</td>
//           <td>${item.product}</td>
//           <td style="text-align:right;">₹${item.price}</td>
//           <td style="text-align:center;">${item.quantity}</td>
//           <td style="text-align:right;">₹${(item.price * item.quantity).toFixed(
//             2
//           )}</td>
//         </tr>
//       `
//         )
//         .join("")}

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Total</td>
//         <td style="text-align:right;">₹${getSubTotal()}</td>
//       </tr>

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Net Amount</td>
//         <td style="text-align:right; font-weight:bold;">₹${getTotalAmount()}</td>
//       </tr>

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Paid</td>
//         <td style="text-align:right;">₹${
//           paymentType === "Credit" ? paidAmount : getTotalAmount()
//         }</td>
//       </tr>
//       ${
//         paymentType === "Credit"
//           ? `
//           <tr style="background:#f5f5f5; font-weight:bold;">
//             <td colspan="4" style="text-align:right;">Balance Due</td>
//             <td style="text-align:right;">₹${getBalance()}</td>
//           </tr>
//         `
//           : ""
//       }
//     </tbody>
//   </table>

//   <table class="no-border" style="width:100%; margin-top:25px;">
//     <tr class="no-border">
//       <td class="no-border" style="text-align:right; font-size:13px; font-weight:bold;">
//         For ஸ்ரீ முருகன் ஆயுர்வேத ஆளோசனை மையம்
//       </td>
//     </tr>
//   </table>

// </div>
// </body>
// </html>
// `;

//       const iframe = document.createElement("iframe");
//       iframe.style.position = "fixed";
//       iframe.style.width = "0";
//       iframe.style.height = "0";
//       iframe.style.border = "0";
//       iframe.srcdoc = billContent; // <-- ✅ instead of write()
//       document.body.appendChild(iframe);

//       iframe.onload = () => {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();
//         setTimeout(() => document.body.removeChild(iframe), 1000);
//       };

//       // Reset cart and customer info
//       setCart([]);
//       setCustomer({ name: "", mobile: "", address: "" });
//       // Reset payment-related fields (paidAmount is still relevant for Credit)
//       setPaymentType("Cash");
//       setPaidAmount(0);

//       setShowRetailForm(false);
//       generateInvoiceNo();
//       fetchProducts();
//       toast.success("Order saved and bill printed successfully!");
//     } catch (err) {
//       console.error("Checkout error:", err);
//       toast.error("Failed to complete retail order");
//     }
//   };

//   const updateQuantity = (id, delta) => {
//     setCart(
//       cart
//         .map((item) => {
//           if (item.id === id) {
//             let newQty = item.quantity + delta;

//             // prevent below 1
//             if (newQty < 1) return null;

//             // prevent exceeding stock
//             if (newQty > item.stock) {
//               toast.error(
//                 `Stock limit reached (${item.stock}) for ${item.product}`
//               );
//               return { ...item, quantity: item.stock };
//             }

//             return { ...item, quantity: newQty };
//           }
//           return item;
//         })
//         .filter(Boolean)
//     );
//   };

//   return (
//     <div>
//       {/* ✅ Hidden input for barcode scanner */}
//       <input
//         ref={inputRef}
//         type="text"
//         onKeyDown={handleScan}
//         style={{ position: "absolute", top: "-100px" }}
//       />

//       <div className="h-[82vh] flex flex-col md:flex-row bg-gray-100 overflow-hidden">
//         {/* Search & Sidebar */}
//         <div className="w-full md:hidden bg-white shadow px-4 py-3 flex items-center justify-between sticky top-0 z-30">
//           <button onClick={() => setSidebarOpen(true)}>
//             <Menu className="text-gray-800" />
//           </button>
//           <h2 className="text-lg font-bold text-green-600">Retail Billing</h2>
//         </div>

//         {/* Sidebar Categories */}
//         <div
//           className={`fixed top-0 left-0 z-40 w-64 h-[85vh] bg-[#0d1224] text-white border-r shadow p-4 overflow-y-auto custom-scrollbar transform transition-transform duration-300 md:relative md:translate-x-0 ${
//             sidebarOpen ? "translate-x-0" : "-translate-x-full"
//           }`}
//         >
//           <div className="flex items-center justify-between mb-4">
//             <h6 className="font-bold">Categories</h6>
//             <button className="md:hidden" onClick={() => setSidebarOpen(false)}>
//               ✕
//             </button>
//           </div>

//           <button
//             className={`w-full text-left mb-2 px-3 py-2 rounded ${
//               selectedCategory === ""
//                 ? "bg-green-600 text-white"
//                 : "hover:bg-gray-700"
//             }`}
//             onClick={() => {
//               setSelectedCategory("");
//               setSidebarOpen(false);
//             }}
//           >
//             All Products
//           </button>

//           {categories.map((cat) => (
//             <button
//               key={cat}
//               className={`w-full text-left mb-2 px-3 py-2 rounded ${
//                 selectedCategory === cat
//                   ? "bg-green-600 text-white"
//                   : "hover:bg-gray-700"
//               }`}
//               onClick={() => {
//                 setSelectedCategory(cat);
//                 setSidebarOpen(false);
//               }}
//             >
//               {cat}
//             </button>
//           ))}
//         </div>

//         {/* Main Body */}
//         <div className="flex-1 flex flex-col md:flex-row">
//           {/* Product List */}
//           <div
//             className="flex-1 p-4 overflow-y-auto custom-scrollbar"
//             style={{ maxHeight: "85vh" }}
//           >
//             <div className="mb-4">
//               <input
//                 type="text"
//                 placeholder="🔍 Search product..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full md:w-1/2 p-2 border border-gray-300 rounded"
//               />
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {filteredProducts.map((item) => (
//                 <div
//                   key={item.id}
//                   onClick={() => item.stock > 0 && addToCart(item)}
//                   className={`border rounded shadow p-2 bg-white cursor-pointer hover:shadow-md transition text-sm ${
//                     item.stock <= 0 ? "opacity-50 pointer-events-none" : ""
//                   }`}
//                 >
//                   {item.image && (
//                     <img
//                       src={item.image}
//                       alt={item.product}
//                       className="w-full h-24 object-cover rounded mb-1"
//                     />
//                   )}
//                   <h6 className="font-semibold text-sm mb-1">{item.product}</h6>
//                   <p className="text-xs text-gray-500 mb-1">₹{item.price}</p>
//                   <p className="text-xs text-gray-500">Stock: {item.stock}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Cart Section */}
//           <div
//             className="w-full md:w-1/3 bg-white p-4 border-t md:border-l md:border-t-0 flex flex-col overflow-y-auto custom-scrollbar"
//             style={{ maxHeight: "85vh" }}
//           >
//             <h5 className="text-lg font-semibold mb-3">
//               🛒 Cart ({cart.length})
//             </h5>

//             {cart.length === 0 ? (
//               <p className="text-gray-500">Your cart is empty.</p>
//             ) : (
//               <>
//                 <div className="space-y-3">
//                   {cart.map((item) => (
//                     <div
//                       key={item.id}
//                       className="flex justify-between items-start p-3 border rounded-lg shadow-sm hover:shadow-md relative"
//                     >
//                       <div>
//                         <strong className="text-gray-900">
//                           {item.product}
//                         </strong>
//                         <div className="text-sm text-gray-500">
//                           ₹{item.price * item.quantity} ({item.quantity}x)
//                         </div>

//                         <div className="flex items-center gap-2 mt-2">
//                           <button
//                             className="px-2 py-1 bg-gray-200 rounded text-lg"
//                             onClick={() => updateQuantity(item.id, -1)}
//                           >
//                             -
//                           </button>
//                           <span className="px-2">{item.quantity}</span>
//                           <button
//                             className="px-2 py-1 bg-gray-200 rounded text-lg"
//                             onClick={() => updateQuantity(item.id, 1)}
//                           >
//                             +
//                           </button>
//                         </div>
//                       </div>

//                       {/* Delete button */}
//                       <button
//                         className="text-red-600 absolute top-2 right-2 hover:text-red-700"
//                         onClick={() => removeFromCart(item.id)}
//                       >
//                         <Trash2 size={18} />
//                       </button>
//                     </div>
//                   ))}
//                 </div>

//                 <div className="font-semibold text-end mt-4 text-gray-800">
//                   Total: ₹{getTotalAmount()}
//                 </div>

//                 <button
//                   className="mt-4 bg-yellow-500 text-white w-full py-2 rounded font-semibold text-lg hover:bg-yellow-600"
//                   onClick={() => {
//                     setIsRetailMode(true);
//                     setShowRetailForm(true);
//                   }}
//                 >
//                   Retail Checkout
//                 </button>

//                 {showRetailForm && (
//                   <div
//                     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
//                     onClick={() => setShowRetailForm(false)} // close only if clicking outside
//                   >
//                     <div
//                       className="bg-white rounded-lg overflow-y-auto shadow-lg w-full mt-10 max-w-md max-h-[80vh]"
//                       onClick={(e) => e.stopPropagation()} // prevent inside clicks from closing
//                     >
//                       <div className="flex justify-between items-center px-4 py-2 border-b">
//                         <h5 className="text-lg text-success font-semibold">
//                           🧍 Customer Details
//                         </h5>
//                         <button
//                           className="text-gray-500 hover:text-gray-700"
//                           onClick={() => setShowRetailForm(false)}
//                         >
//                           ✕
//                         </button>
//                       </div>
//                       <div className="p-4">
//                         <input
//                           type="text"
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           placeholder="Customer Name"
//                           value={customer.name}
//                           onChange={(e) =>
//                             setCustomer({ ...customer, name: e.target.value })
//                           }
//                         />

//                         <input
//                           type="tel"
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           placeholder="Mobile Number"
//                           value={customer.mobile}
//                           onChange={(e) =>
//                             setCustomer({
//                               ...customer,
//                               mobile: e.target.value
//                                 .replace(/\D/g, "")
//                                 .slice(0, 10), // ✅ only numbers, max 10
//                             })
//                           }
//                           maxLength={10}
//                         />

//                         <textarea
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           placeholder="Address"
//                           value={customer.address}
//                           onChange={(e) =>
//                             setCustomer({
//                               ...customer,
//                               address: e.target.value,
//                             })
//                           }
//                         />
//                         {/* ❌ REMOVED: Discount % input */}

//                         {/* Payment Type */}
//                         <select
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           value={paymentType}
//                           onChange={(e) => setPaymentType(e.target.value)}
//                         >
//                           <option value="Cash">Cash</option>
//                           <option value="Online">Online Payment</option>
//                           <option value="Credit">Credit</option>
//                         </select>
//                         {/* Paid Amount if Credit */}
//                         {paymentType === "Credit" && (
//                           <input
//                             type="number"
//                             className="w-full border rounded px-3 py-2 mb-3"
//                             placeholder="Paid Amount"
//                             value={paidAmount}
//                             onChange={(e) =>
//                               setPaidAmount(Number(e.target.value))
//                             }
//                             min={0}
//                             max={getTotalAmount()}
//                           />
//                         )}
//                         <div className="font-semibold text-end text-gray-800 mb-3">
//                           Total: ₹{getTotalAmount()} <br />
//                           {paymentType === "Credit" && (
//                             <>
//                               Paid: ₹{paidAmount} <br />
//                               Balance Due: ₹{getBalance()}
//                             </>
//                           )}
//                         </div>
//                         <button
//                           className="w-full bg-green-600 text-white py-2 rounded font-semibold hover:bg-green-700"
//                           onClick={handleRetailCheckout}
//                         >
//                           Print & Save
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Retail;

// import React, { useState, useEffect, useRef } from "react";
// import { toast } from "sonner";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import { Menu, Trash2 } from "lucide-react";
// import { Api } from "../Api/Api";

// function Retail() {
//   const location = useLocation();
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [cart, setCart] = useState([]);
//   const [showRetailForm, setShowRetailForm] = useState(false);
//   const [customer, setCustomer] = useState({
//     name: "",
//     mobile: "",
//     place: "", // changed from address -> place
//     height: "", // new
//     weight: "", // new
//   });
//   const [isRetailMode, setIsRetailMode] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // const [discount, setDiscount] = useState(0); // ❌ REMOVED: total discount %
//   const [paymentType, setPaymentType] = useState("Cash");
//   const [paidAmount, setPaidAmount] = useState(0);

//   const [username, setUsername] = useState("");

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("currentUser"));
//     if (user) {
//       setUsername(user.username); // ✅ store username in state
//     }
//   }, []);

//   // ✅ New states for invoice
//   const [invoiceNo, setInvoiceNo] = useState("");
//   const inputRef = useRef(null);

//   useEffect(() => {
//     fetchProducts();
//     generateInvoiceNo();
//   }, [location.pathname]);

//   // ✅ Auto-generate invoice no
//   const generateInvoiceNo = () => {
//     const now = new Date();
//     const unique = "INV" + now.getTime(); // Eg: INV1692523244231
//     setInvoiceNo(unique);
//   };

//   const filteredProducts = (
//     selectedCategory
//       ? products.filter((p) => p.category === selectedCategory)
//       : products
//   ).filter((p) => p.product.toLowerCase().includes(searchTerm.toLowerCase()));

//   const addToCart = (product) => {
//     const exists = cart.find((item) => item.id === product.id);
//     if (exists) {
//       // stop if quantity already reached stock
//       if (exists.quantity >= product.stock) {
//         toast.error(
//           `Only ${product.stock} stock available for ${product.product}`
//         );
//         return;
//       }
//       setCart(
//         cart.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         )
//       );
//     } else {
//       if (product.stock < 1) {
//         toast.error(`No stock available for ${product.product}`);
//         return;
//       }
//       setCart([...cart, { ...product, quantity: 1 }]);
//     }
//   };

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(`${Api}product/read.php`);
//       const allProducts = res.data;
//       setProducts(allProducts);
//       const uniqueCats = [
//         ...new Set(allProducts.map((p) => p.category).filter(Boolean)),
//       ];
//       setCategories(uniqueCats);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     }
//   };
//   // ✅ Always keep scanner input focused
//   useEffect(() => {
//     inputRef.current.focus();
//     const handleFocus = () => inputRef.current.focus();
//     window.addEventListener("click", handleFocus);
//     return () => window.removeEventListener("click", handleFocus);
//   }, []);

//   // ✅ Handle barcode scan
//   const handleScan = (e) => {
//     if (e.key === "Enter") {
//       const scannedCode = e.target.value.trim();
//       e.target.value = "";

//       const product = products.find((p) => p.barcode === scannedCode);
//       if (product) {
//         addToCart(product);
//         toast.success(`${product.product} added to cart`);
//       } else {
//         toast.error("No product matches this barcode");
//       }
//     }
//   };
//   const removeFromCart = (id) => {
//     setCart(cart.filter((item) => item.id !== id));
//   };
//   const getSubTotal = () => {
//     return cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
//   };

//   // ❌ REMOVED: getDiscountAmount function

//   const getTotalAmount = () => getSubTotal(); // ✅ Total is now just SubTotal

//   const getBalance = () => {
//     if (paymentType === "Credit") {
//       return Math.max(0, getTotalAmount() - paidAmount);
//     }
//     return 0;
//   };

//   const handleRetailCheckout = async () => {
//     if (!customer.name || !customer.mobile || !customer.place) {
//       return toast.error("Enter all customer details");
//     }

//     // ✅ Mobile number validation (must be 10 digits)
//     if (!/^\d{10}$/.test(customer.mobile)) {
//       return toast.error("Enter a valid 10-digit mobile number");
//     }

//     const retailOrder = {
//       invoiceNo,
//       customer,
//       cart,
//       subtotal: getSubTotal(),
//       // ❌ REMOVED: discount, discountamount fields
//       total: getTotalAmount(),
//       paymentType,
//       paidAmount: paymentType === "Credit" ? paidAmount : getTotalAmount(),
//       balance: getBalance(),
//       timestamp: new Date().toISOString(),
//       date: new Date().toLocaleDateString(),
//       billername: username,
//     };

//     try {
//       const res = await axios.post(
//         `${Api}retail/retail_save.php`,
//         retailOrder,
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       const invoiceNo = res.data.invoiceNo;

//       console.log("📦 Data being sent to backend:", retailOrder);

//       await Promise.all(
//         cart.map((item) =>
//           axios.put(
//             `${Api}product/update.php?id=${item.id}`,
//             { stock: item.stock - item.quantity },
//             { headers: { "Content-Type": "application/json" } }
//           )
//         )
//       );

//       const billContent = `
// <html>
// <head>
//   <title>Invoice ${invoiceNo}</title>
//   <style>
//     body {
//       font-family: 'Arial', sans-serif;
//       font-size: 12px;
//       color: #000;
//       margin:0;
//       padding:0;
//       display:flex;
//       justify-content:center;
//       align-items:center;
//     }

//     .page {
//       width: 186mm;
//       height: 273mm;
//       border: 2px solid #000;
//       padding: 8mm;
//       box-sizing: border-box;
//       margin: 12mm auto;
//       position: relative;
//     }

//     table { border-collapse: collapse; width: 100%; }
//     th, td { border: 1px solid #000; padding: 6px; font-size: 12px; }
//     th { font-weight: bold; text-align: center; font-size: 13px; }
//     .no-border { border: none !important; }

//     .watermark {
//       position: absolute;
//       top: 50%; left: 50%;
//       transform: translate(-50%, -50%);
//       opacity: 0.07;
//       z-index: 0;
//     }
//     .watermark img { width: 380px; height: auto; }

//     .header-table td { border: none !important; vertical-align: middle; }

//     @media print {
//       @page { size: A4; margin: 0; }
//       body { margin: 0; }
//     }
//   </style>
// </head>
// <body>

// <div class="page">

//   <div class="watermark">
//     <img src="/logo.jpg" />
//   </div>

//   <table class="header-table" style="margin-bottom:12px; position:relative; z-index:1; width:100%;">
//     <tr>
//       <td style="width:15%; text-align:center;">
//         <img src="/logo.jpg" style="width:100px; height:100px;" />
//       </td>
//       <td style="text-align:center;">
//         <div style="display:flex; flex-direction:column; align-items:center; justify-content:center;">
//           <h2 style="margin:0; font-size:20px; font-weight:bold;">
//             ஸ்ரீ முருகன் ஆயுர்வேத ஆளோசனை மையம்
//           </h2>
//           <p style="margin:2px 0; font-size:11px;">
//             142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301
//           </p>
//           <p style="margin:2px 0; font-size:11px;">
//             📞 99408 32688 / 90801 99109 &nbsp;&nbsp; ✉️ srimuruganayurveda@gmail.com
//           </p>
//         </div>
//       </td>
//       <td style="width:22%; text-align:right; font-size:12px;">
//         <p><b>Invoice No:</b> ${invoiceNo}</p>
//         <p><b>Date:</b> ${new Date().toLocaleDateString("en-GB", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//         })}</p>
//       </td>
//     </tr>
//   </table>

//   <table style="margin-bottom:12px; position:relative; z-index:1; width:100%;">
//     <tr>
//       <td style="padding:6px; font-size:12px;">
//         <b>To M/s:</b> ${customer.name}, ${customer.place}<br/><br/>
//         <b>Mobile:</b> ${customer.mobile}<br/>
//         <b>Height:</b> ${customer.height || "-"} &nbsp;&nbsp; <b>Weight:</b> ${
//         customer.weight || "-"
//       }
//       </td>
//     </tr>
//   </table>

//   <table style="position:relative; z-index:1; width:100%; margin-bottom:15px;">
//     <thead>
//       <tr>
//         <th style="width:8%;">S.No</th>
//         <th style="width:42%;">Particulars</th>
//         <th style="width:15%;">Rate</th>
//         <th style="width:10%;">Qty</th>
//         <th style="width:25%;">Amount</th>
//       </tr>
//     </thead>
//     <tbody>
//       ${cart
//         .map(
//           (item, idx) => `
//         <tr>
//           <td style="text-align:center;">${idx + 1}</td>
//           <td>${item.product}</td>
//           <td style="text-align:right;">₹${item.price}</td>
//           <td style="text-align:center;">${item.quantity}</td>
//           <td style="text-align:right;">₹${(item.price * item.quantity).toFixed(
//             2
//           )}</td>
//         </tr>
//       `
//         )
//         .join("")}

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Total</td>
//         <td style="text-align:right;">₹${getSubTotal()}</td>
//       </tr>

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Net Amount</td>
//         <td style="text-align:right; font-weight:bold;">₹${getTotalAmount()}</td>
//       </tr>

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Paid</td>
//         <td style="text-align:right;">₹${
//           paymentType === "Credit" ? paidAmount : getTotalAmount()
//         }</td>
//       </tr>
//       ${
//         paymentType === "Credit"
//           ? `
//           <tr style="background:#f5f5f5; font-weight:bold;">
//             <td colspan="4" style="text-align:right;">Balance Due</td>
//             <td style="text-align:right;">₹${getBalance()}</td>
//           </tr>
//         `
//           : ""
//       }
//     </tbody>
//   </table>

//   <table class="no-border" style="width:100%; margin-top:25px;">
//     <tr class="no-border">
//       <td class="no-border" style="text-align:right; font-size:13px; font-weight:bold;">
//         For ஸ்ரீ முருகன் ஆயுர்வேத ஆளோசனை மையம்
//       </td>
//     </tr>
//   </table>

// </div>
// </body>
// </html>
// `;

//       const iframe = document.createElement("iframe");
//       iframe.style.position = "fixed";
//       iframe.style.width = "0";
//       iframe.style.height = "0";
//       iframe.style.border = "0";
//       iframe.srcdoc = billContent; // <-- ✅ instead of write()
//       document.body.appendChild(iframe);

//       iframe.onload = () => {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();
//         setTimeout(() => document.body.removeChild(iframe), 1000);
//       };

//       // Reset cart and customer info
//       setCart([]);
//       setCustomer({ name: "", mobile: "", place: "", height: "", weight: "" });
//       // Reset payment-related fields (paidAmount is still relevant for Credit)
//       setPaymentType("Cash");
//       setPaidAmount(0);

//       setShowRetailForm(false);
//       generateInvoiceNo();
//       fetchProducts();
//       toast.success("Order saved and bill printed successfully!");
//     } catch (err) {
//       console.error("Checkout error:", err);
//       toast.error("Failed to complete retail order");
//     }
//   };

//   const updateQuantity = (id, delta) => {
//     setCart(
//       cart
//         .map((item) => {
//           if (item.id === id) {
//             let newQty = item.quantity + delta;

//             // prevent below 1
//             if (newQty < 1) return null;

//             // prevent exceeding stock
//             if (newQty > item.stock) {
//               toast.error(
//                 `Stock limit reached (${item.stock}) for ${item.product}`
//               );
//               return { ...item, quantity: item.stock };
//             }

//             return { ...item, quantity: newQty };
//           }
//           return item;
//         })
//         .filter(Boolean)
//     );
//   };

//   return (
//     <div>
//       {/* ✅ Hidden input for barcode scanner */}
//       <input
//         ref={inputRef}
//         type="text"
//         onKeyDown={handleScan}
//         style={{ position: "absolute", top: "-100px" }}
//       />

//       <div className="h-[82vh] flex flex-col md:flex-row bg-gray-100 overflow-hidden">
//         {/* Search & Sidebar */}
//         <div className="w-full md:hidden bg-white shadow px-4 py-3 flex items-center justify-between sticky top-0 z-30">
//           <button onClick={() => setSidebarOpen(true)}>
//             <Menu className="text-gray-800" />
//           </button>
//           <h2 className="text-lg font-bold text-green-600">Retail Billing</h2>
//         </div>

//         {/* Sidebar Categories */}
//         <div
//           className={`fixed top-0 left-0 z-40 w-64 h-[85vh] bg-[#0d1224] text-white border-r shadow p-4 overflow-y-auto custom-scrollbar transform transition-transform duration-300 md:relative md:translate-x-0 ${
//             sidebarOpen ? "translate-x-0" : "-translate-x-full"
//           }`}
//         >
//           <div className="flex items-center justify-between mb-4">
//             <h6 className="font-bold">Categories</h6>
//             <button className="md:hidden" onClick={() => setSidebarOpen(false)}>
//               ✕
//             </button>
//           </div>

//           <button
//             className={`w-full text-left mb-2 px-3 py-2 rounded ${
//               selectedCategory === ""
//                 ? "bg-green-600 text-white"
//                 : "hover:bg-gray-700"
//             }`}
//             onClick={() => {
//               setSelectedCategory("");
//               setSidebarOpen(false);
//             }}
//           >
//             All Products
//           </button>

//           {categories.map((cat) => (
//             <button
//               key={cat}
//               className={`w-full text-left mb-2 px-3 py-2 rounded ${
//                 selectedCategory === cat
//                   ? "bg-green-600 text-white"
//                   : "hover:bg-gray-700"
//               }`}
//               onClick={() => {
//                 setSelectedCategory(cat);
//                 setSidebarOpen(false);
//               }}
//             >
//               {cat}
//             </button>
//           ))}
//         </div>

//         {/* Main Body */}
//         <div className="flex-1 flex flex-col md:flex-row">
//           {/* Product List */}
//           <div
//             className="flex-1 p-4 overflow-y-auto custom-scrollbar"
//             style={{ maxHeight: "85vh" }}
//           >
//             <div className="mb-4">
//               <input
//                 type="text"
//                 placeholder="🔍 Search product..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full md:w-1/2 p-2 border border-gray-300 rounded"
//               />
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {filteredProducts.map((item) => (
//                 <div
//                   key={item.id}
//                   onClick={() => item.stock > 0 && addToCart(item)}
//                   className={`border rounded shadow p-2 bg-white cursor-pointer hover:shadow-md transition text-sm ${
//                     item.stock <= 0 ? "opacity-50 pointer-events-none" : ""
//                   }`}
//                 >
//                   {item.image && (
//                     <img
//                       src={item.image}
//                       alt={item.product}
//                       className="w-full h-24 object-cover rounded mb-1"
//                     />
//                   )}
//                   <h6 className="font-semibold text-sm mb-1">{item.product}</h6>
//                   <p className="text-xs text-gray-500 mb-1">₹{item.price}</p>
//                   <p className="text-xs text-gray-500">Stock: {item.stock}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Cart Section */}
//           <div
//             className="w-full md:w-1/3 bg-white p-4 border-t md:border-l md:border-t-0 flex flex-col overflow-y-auto custom-scrollbar"
//             style={{ maxHeight: "85vh" }}
//           >
//             <h5 className="text-lg font-semibold mb-3">
//               🛒 Cart ({cart.length})
//             </h5>

//             {cart.length === 0 ? (
//               <p className="text-gray-500">Your cart is empty.</p>
//             ) : (
//               <>
//                 <div className="space-y-3">
//                   {cart.map((item) => (
//                     <div
//                       key={item.id}
//                       className="flex justify-between items-start p-3 border rounded-lg shadow-sm hover:shadow-md relative"
//                     >
//                       <div>
//                         <strong className="text-gray-900">
//                           {item.product}
//                         </strong>
//                         <div className="text-sm text-gray-500">
//                           ₹{item.price * item.quantity} ({item.quantity}x)
//                         </div>

//                         <div className="flex items-center gap-2 mt-2">
//                           <button
//                             className="px-2 py-1 bg-gray-200 rounded text-lg"
//                             onClick={() => updateQuantity(item.id, -1)}
//                           >
//                             -
//                           </button>
//                           <span className="px-2">{item.quantity}</span>
//                           <button
//                             className="px-2 py-1 bg-gray-200 rounded text-lg"
//                             onClick={() => updateQuantity(item.id, 1)}
//                           >
//                             +
//                           </button>
//                         </div>
//                       </div>

//                       {/* Delete button */}
//                       <button
//                         className="text-red-600 absolute top-2 right-2 hover:text-red-700"
//                         onClick={() => removeFromCart(item.id)}
//                       >
//                         <Trash2 size={18} />
//                       </button>
//                     </div>
//                   ))}
//                 </div>

//                 <div className="font-semibold text-end mt-4 text-gray-800">
//                   Total: ₹{getTotalAmount()}
//                 </div>

//                 <button
//                   className="mt-4 bg-yellow-500 text-white w-full py-2 rounded font-semibold text-lg hover:bg-yellow-600"
//                   onClick={() => {
//                     setIsRetailMode(true);
//                     setShowRetailForm(true);
//                   }}
//                 >
//                   Retail Checkout
//                 </button>

//                 {showRetailForm && (
//                   <div
//                     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
//                     onClick={() => setShowRetailForm(false)}
//                   >
//                     <div
//                       className="bg-white rounded-lg shadow-lg w-full mt-10 max-w-sm"
//                       onClick={(e) => e.stopPropagation()}
//                     >
//                       <div className="flex justify-between items-center px-4 py-2 border-b">
//                         <h5 className="text-lg text-success font-semibold">
//                           🧍 Customer Details
//                         </h5>
//                         <button
//                           className="text-gray-500 hover:text-gray-700"
//                           onClick={() => setShowRetailForm(false)}
//                         >
//                           ✕
//                         </button>
//                       </div>

//                       <div className="p-4">
//                         <input
//                           type="text"
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           placeholder="Customer Name"
//                           value={customer.name}
//                           onChange={(e) =>
//                             setCustomer({ ...customer, name: e.target.value })
//                           }
//                         />

//                         <input
//                           type="tel"
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           placeholder="Mobile Number"
//                           value={customer.mobile}
//                           onChange={(e) =>
//                             setCustomer({
//                               ...customer,
//                               mobile: e.target.value
//                                 .replace(/\D/g, "")
//                                 .slice(0, 10),
//                             })
//                           }
//                           maxLength={10}
//                         />

//                         <input
//                           type="text"
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           placeholder="Place"
//                           value={customer.place}
//                           onChange={(e) =>
//                             setCustomer({ ...customer, place: e.target.value })
//                           }
//                         />

//                         {/* HEIGHT / WEIGHT / (PAID IF CREDIT) — placed in a single responsive row so modal doesn't grow */}
//                         <div
//                           className={`grid gap-2 mb-3 ${
//                             paymentType === "Credit"
//                               ? "grid-cols-3"
//                               : "grid-cols-2"
//                           } items-center`}
//                         >
//                           <input
//                             type="text"
//                             className="border rounded px-3 py-2 w-full"
//                             placeholder="Height (e.g., 170 cm or 5\6)"
//                             value={customer.height}
//                             onChange={(e) =>
//                               setCustomer({
//                                 ...customer,
//                                 height: e.target.value,
//                               })
//                             }
//                           />
//                           <input
//                             type="text"
//                             className="border rounded px-3 py-2 w-full"
//                             placeholder="Weight (e.g., 65 kg)"
//                             value={customer.weight}
//                             onChange={(e) =>
//                               setCustomer({
//                                 ...customer,
//                                 weight: e.target.value,
//                               })
//                             }
//                           />
//                           {paymentType === "Credit" && (
//                             <input
//                               type="number"
//                               className="border rounded px-3 py-2 w-full"
//                               placeholder="Paid Amount"
//                               value={paidAmount}
//                               onChange={(e) =>
//                                 setPaidAmount(Number(e.target.value))
//                               }
//                               min={0}
//                               max={getTotalAmount()}
//                             />
//                           )}
//                         </div>

//                         {/* Payment Type */}
//                         <select
//                           className="w-full border rounded px-3 py-2 mb-3"
//                           value={paymentType}
//                           onChange={(e) => setPaymentType(e.target.value)}
//                         >
//                           <option value="Cash">Cash</option>
//                           <option value="Online">Online Payment</option>
//                           <option value="Credit">Credit</option>
//                         </select>

//                         <div className="font-semibold text-end text-gray-800 mb-3">
//                           Total: ₹{getTotalAmount()} <br />
//                           {paymentType === "Credit" && (
//                             <>
//                               Paid: ₹{paidAmount} <br />
//                               Balance Due: ₹{getBalance()}
//                             </>
//                           )}
//                         </div>

//                         <button
//                           className="w-full bg-green-600 text-white py-2 rounded font-semibold hover:bg-green-700"
//                           onClick={handleRetailCheckout}
//                         >
//                           Print & Save
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Retail;

// src/pages/Retail.jsx
import React, { useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Menu, Trash2 } from "lucide-react";
import { Api } from "../Api/Api";
import BillPrint from "./BillPrint"; // adjust path if needed

function Retail() {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [cart, setCart] = useState([]);
  const [showRetailForm, setShowRetailForm] = useState(false);

  const [customer, setCustomer] = useState({
    name: "",
    mobile: "",
    place: "", // changed from address -> place
    height: "", // new
    weight: "", // new
    dob: "", // added DOB (ISO date string from <input type="date">)
  });

  const [isRetailMode, setIsRetailMode] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [paymentType, setPaymentType] = useState("Cash");
  const [paidAmount, setPaidAmount] = useState(0);
  const [username, setUsername] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const inputRef = useRef(null);

  // New: printData handed to BillPrint
  const [printData, setPrintData] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (user) {
      setUsername(user.username);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
    generateInvoiceNo();
    // regenerate invoice whenever path changes (like your original)
  }, [location.pathname]);

  // Always focus barcode input
  // useEffect(() => {
  //   if (inputRef.current) inputRef.current.focus();
  //   const handleFocus = () => inputRef.current && inputRef.current.focus();
  //   window.addEventListener("click", handleFocus);
  //   return () => window.removeEventListener("click", handleFocus);
  // }, []);

  // Always keep scanner input focused (but avoid stealing focus from form inputs)
  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();

    const handleFocus = (e) => {
      const tag = e.target.tagName.toLowerCase();
      if (tag !== "input" && tag !== "textarea" && tag !== "select") {
        if (inputRef.current) inputRef.current.focus();
      }
    };

    window.addEventListener("click", handleFocus);
    return () => window.removeEventListener("click", handleFocus);
  }, []);

  const generateInvoiceNo = () => {
    const now = new Date();
    const unique = "INV" + now.getTime();
    setInvoiceNo(unique);
  };

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${Api}product/read.php`);
      const allProducts = res.data || [];
      setProducts(allProducts);
      const uniqueCats = [
        ...new Set(allProducts.map((p) => p.category).filter(Boolean)),
      ];
      setCategories(uniqueCats);
    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Failed to fetch products");
    }
  };

  const filteredProducts = (
    selectedCategory
      ? products.filter((p) => p.category === selectedCategory)
      : products
  ).filter((p) => p.product.toLowerCase().includes(searchTerm.toLowerCase()));

  const addToCart = (product) => {
    const exists = cart.find((item) => item.id === product.id);
    if (exists) {
      if (exists.quantity >= product.stock) {
        toast.error(
          `Only ${product.stock} stock available for ${product.product}`
        );
        return;
      }
      setCart(
        cart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      if (product.stock < 1) {
        toast.error(`No stock available for ${product.product}`);
        return;
      }
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const handleScan = (e) => {
    if (e.key === "Enter") {
      const scannedCode = e.target.value.trim();
      e.target.value = "";
      const product = products.find((p) => p.barcode === scannedCode);
      if (product) {
        addToCart(product);
        toast.success(`${product.product} added to cart`);
      } else {
        toast.error("No product matches this barcode");
      }
    }
  };

  const removeFromCart = (id) => {
    setCart(cart.filter((item) => item.id !== id));
  };

  const getSubTotal = () =>
    cart.reduce(
      (acc, item) => acc + Number(item.retail_price) * Number(item.quantity),
      0
    );

  const getTotalAmount = () => getSubTotal();

  const getBalance = () => {
    if (paymentType === "Credit") {
      return Math.max(0, getTotalAmount() - paidAmount);
    }
    return 0;
  };

  // Checkout: save order, update stock, then hand off to BillPrint via setPrintData
  const handleRetailCheckout = async () => {
    if (!customer.name || !customer.mobile || !customer.place) {
      return toast.error("Enter all customer details");
    }

    if (!/^\d{10}$/.test(customer.mobile)) {
      return toast.error("Enter a valid 10-digit mobile number");
    }

    if (cart.length === 0) {
      return toast.error("Cart is empty");
    }

    const retailOrder = {
      invoiceNo,
      customer,
      cart,
      subtotal: getSubTotal(),
      total: getTotalAmount(),
      paymentType,
      paidAmount: paymentType === "Credit" ? paidAmount : getTotalAmount(),
      balance: getBalance(),
      timestamp: new Date().toISOString(),
      date: new Date().toLocaleDateString(),
      billername: username,
    };

    try {
      // 1) Save order
      const res = await axios.post(
        `${Api}retail/retail_save.php`,
        retailOrder,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // backend may return invoiceNo
      const returnedInvoice = res.data?.invoiceNo || invoiceNo;

      console.log("📦 Data sent to backend:", retailOrder);

      // 2) Update stock for each item (concurrently)
      await Promise.all(
        cart.map((item) =>
          axios.put(
            `${Api}product/update.php?id=${item.id}`,
            { stock: Number(item.stock) - Number(item.quantity) },
            { headers: { "Content-Type": "application/json" } }
          )
        )
      );

      // 3) Hand off to BillPrint component to create iframe & print
      setPrintData({
        invoiceNo: returnedInvoice,
        customer,
        cart,
        paymentType,
        paidAmount,
        billername: username,
      });

      // DO NOT reset cart here — cleanup will happen in onDone after print
    } catch (err) {
      console.error("Checkout error:", err);
      toast.error("Failed to complete retail order");
    }
  };

  const updateQuantity = (id, delta) => {
    setCart(
      cart
        .map((item) => {
          if (item.id === id) {
            let newQty = item.quantity + delta;
            if (newQty < 1) return null;
            if (newQty > item.stock) {
              toast.error(
                `Stock limit reached (${item.stock}) for ${item.product}`
              );
              return { ...item, quantity: item.stock };
            }
            return { ...item, quantity: newQty };
          }
          return item;
        })
        .filter(Boolean)
    );
  };

  return (
    <div>
      {/* Hidden barcode scanner input */}
      <input
        ref={inputRef}
        type="text"
        onKeyDown={handleScan}
        style={{ position: "absolute", top: "-100px" }}
      />

      <div className="h-[82vh] flex flex-col md:flex-row bg-gray-100 overflow-hidden">
        {/* Mobile top bar */}
        <div className="w-full md:hidden bg-white shadow px-4 py-3 flex items-center justify-between sticky top-0 z-30">
          <button onClick={() => setSidebarOpen(true)}>
            <Menu className="text-gray-800" />
          </button>
          <h2 className="text-lg font-bold text-green-600">Retail Billing</h2>
        </div>

        {/* Sidebar Categories */}
        <div
          className={`fixed top-0 left-0 z-40 w-64 h-[85vh] bg-[#0d1224] text-white border-r shadow p-4 overflow-y-auto custom-scrollbar transform transition-transform duration-300 md:relative md:translate-x-0 ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between mb-4">
            <h6 className="font-bold">Categories</h6>
            <button className="md:hidden" onClick={() => setSidebarOpen(false)}>
              ✕
            </button>
          </div>

          <button
            className={`w-full text-left mb-2 px-3 py-2 rounded ${
              selectedCategory === ""
                ? "bg-green-600 text-white"
                : "hover:bg-gray-700"
            }`}
            onClick={() => {
              setSelectedCategory("");
              setSidebarOpen(false);
            }}
          >
            All Products
          </button>

          {categories.map((cat) => (
            <button
              key={cat}
              className={`w-full text-left mb-2 px-3 py-2 rounded ${
                selectedCategory === cat
                  ? "bg-green-600 text-white"
                  : "hover:bg-gray-700"
              }`}
              onClick={() => {
                setSelectedCategory(cat);
                setSidebarOpen(false);
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Main Body */}
        <div className="flex-1 flex flex-col md:flex-row">
          {/* Product List */}
          <div
            className="flex-1 p-4 overflow-y-auto custom-scrollbar"
            style={{ maxHeight: "85vh" }}
          >
            <div className="mb-4">
              <input
                type="text"
                placeholder="🔍 Search product..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full md:w-1/2 p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredProducts.map((item) => (
                <div
                  key={item.id}
                  onClick={() => item.stock > 0 && addToCart(item)}
                  className={`border rounded shadow p-2 bg-white cursor-pointer hover:shadow-md transition text-sm ${
                    item.stock <= 0 ? "opacity-50 pointer-events-none" : ""
                  }`}
                >
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.product}
                      className="w-full h-24 object-cover rounded mb-1"
                    />
                  )}
                  {/* <h6 className="font-semibold text-sm mb-1">{item.product}</h6> */}
                  <div
                    className="font-medium text-gray-900 text-center leading-tight break-all"
                    style={{
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {item.product}
                  </div>
                  <p className="text-xs text-gray-500 text-center mb-1 mt-1">
                    Price: ₹{item.retail_price}
                  </p>
                  <p className="text-xs text-center text-gray-500">
                    Stock: {item.stock}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Cart Section */}
          <div
            className="w-full md:w-1/3 bg-white p-4 border-t md:border-l md:border-t-0 flex flex-col overflow-y-auto custom-scrollbar"
            style={{ maxHeight: "85vh" }}
          >
            <h5 className="text-lg font-semibold mb-3">
              🛒 Cart ({cart.length})
            </h5>

            {cart.length === 0 ? (
              <p className="text-gray-500">Your cart is empty.</p>
            ) : (
              <>
                <div className="space-y-3">
                  {cart.map((item) => (
                    <div
                      key={item.id}
                      className="flex justify-between items-start p-3 border rounded-lg shadow-sm hover:shadow-md relative"
                    >
                      <div>
                        <strong className="text-gray-900">
                          {item.product}
                        </strong>
                        <div className="text-sm text-gray-500">
                          ₹{item.retail_price * item.quantity} ({item.quantity}
                          x)
                        </div>

                        <div className="flex items-center gap-2 mt-2">
                          <button
                            className="px-2 py-1 bg-gray-200 rounded text-lg"
                            onClick={() => updateQuantity(item.id, -1)}
                          >
                            -
                          </button>
                          <span className="px-2">{item.quantity}</span>
                          <button
                            className="px-2 py-1 bg-gray-200 rounded text-lg"
                            onClick={() => updateQuantity(item.id, 1)}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      {/* Delete button */}
                      <button
                        className="text-red-600 absolute top-2 right-2 hover:text-red-700"
                        onClick={() => removeFromCart(item.id)}
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="font-semibold text-end mt-4 text-gray-800">
                  Total: ₹{getTotalAmount()}
                </div>

                <button
                  className="mt-4 bg-yellow-500 text-white w-full py-2 rounded font-semibold text-lg hover:bg-yellow-600"
                  onClick={() => {
                    setIsRetailMode(true);
                    setShowRetailForm(true);
                  }}
                >
                  Retail Checkout
                </button>

                {/* Customer Modal */}
                {showRetailForm && (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={() => setShowRetailForm(false)}
                  >
                    <div
                      className="bg-white rounded-lg shadow-lg w-full mt-10 max-w-sm"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="flex justify-between items-center px-4 py-2 border-b">
                        <h5 className="text-lg text-success font-semibold">
                          🧍 Customer Details
                        </h5>
                        <button
                          className="text-gray-500 hover:text-gray-700"
                          onClick={() => setShowRetailForm(false)}
                        >
                          ✕
                        </button>
                      </div>

                      <div className="p-4">
                        <input
                          type="text"
                          className="w-full border rounded px-3 py-2 mb-3"
                          placeholder="Customer Name"
                          value={customer.name}
                          onChange={(e) =>
                            setCustomer({ ...customer, name: e.target.value })
                          }
                        />

                        <input
                          type="tel"
                          className="w-full border rounded px-3 py-2 mb-3"
                          placeholder="Mobile Number"
                          value={customer.mobile}
                          onChange={(e) =>
                            setCustomer({
                              ...customer,
                              mobile: e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10),
                            })
                          }
                          maxLength={10}
                        />

                        <input
                          type="text"
                          className="w-full border rounded px-3 py-2 mb-3"
                          placeholder="Place"
                          value={customer.place}
                          onChange={(e) =>
                            setCustomer({ ...customer, place: e.target.value })
                          }
                        />
                        <input
                          type="date"
                          className="w-full border rounded px-3 py-2 mb-3"
                          placeholder="Date of Birth"
                          value={customer.dob}
                          onChange={(e) =>
                            setCustomer({ ...customer, dob: e.target.value })
                          }
                        />

                        <div
                          className={`grid gap-2 mb-3 ${
                            paymentType === "Credit"
                              ? "grid-cols-3"
                              : "grid-cols-2"
                          } items-center`}
                        >
                          <input
                            type="text"
                            className="border rounded px-3 py-2 w-full"
                            placeholder="Height (e.g., 170 cm or 5'6\)"
                            value={customer.height}
                            onChange={(e) =>
                              setCustomer({
                                ...customer,
                                height: e.target.value,
                              })
                            }
                          />
                          <input
                            type="text"
                            className="border rounded px-3 py-2 w-full"
                            placeholder="Weight (e.g., 65 kg)"
                            value={customer.weight}
                            onChange={(e) =>
                              setCustomer({
                                ...customer,
                                weight: e.target.value,
                              })
                            }
                          />
                          {paymentType === "Credit" && (
                            <input
                              type="number"
                              className="border rounded px-3 py-2 w-full"
                              placeholder="Paid Amount"
                              value={paidAmount}
                              onChange={(e) =>
                                setPaidAmount(Number(e.target.value))
                              }
                              min={0}
                              max={getTotalAmount()}
                            />
                          )}
                        </div>

                        <select
                          className="w-full border rounded px-3 py-2 mb-3"
                          value={paymentType}
                          onChange={(e) => setPaymentType(e.target.value)}
                        >
                          <option value="Cash">Cash</option>
                          <option value="Online">Online Payment</option>
                          <option value="Credit">Credit</option>
                        </select>

                        <div className="font-semibold text-end text-gray-800 mb-3">
                          Total: ₹{getTotalAmount()}
                          <br />
                          {paymentType === "Credit" && (
                            <>
                              Paid: ₹{paidAmount} <br />
                              Balance Due: ₹{getBalance()}
                            </>
                          )}
                        </div>

                        <button
                          className="w-full bg-green-600 text-white py-2 rounded font-semibold hover:bg-green-700"
                          onClick={handleRetailCheckout}
                        >
                          Print & Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* BillPrint: renders nothing visually, creates iframe and prints when printData set */}
      {printData && (
        <BillPrint
          invoiceNo={printData.invoiceNo}
          customer={printData.customer}
          cart={printData.cart}
          paymentType={printData.paymentType}
          paidAmount={printData.paidAmount}
          getSubTotal={() => getSubTotal()}
          getTotalAmount={() => getTotalAmount()}
          getBalance={() => getBalance()}
          billername={printData.billername}
          logoPath="/logo.png"
          logoPath1="/logo1.png"
          onDone={() => {
            // cleanup AFTER printing (BillPrint calls this)
            setCart([]);
            setCustomer({
              name: "",
              mobile: "",
              place: "",
              height: "",
              weight: "",
            });
            setPaymentType("Cash");
            setPaidAmount(0);
            setShowRetailForm(false);
            generateInvoiceNo();
            fetchProducts();
            toast.success("Order saved and bill printed successfully!");
            setPrintData(null);
          }}
        />
      )}
    </div>
  );
}

export default Retail;
